import classnames from 'classnames/bind';
import { Drawer } from '@mantine/core';

import { DashboardWidget } from 'types/dashboard_widget';

import { useModal } from 'hooks/useModal';

import { WidgetForm } from './Form';

import styles from './WidgetDrawer.module.scss';

const c = classnames.bind(styles);

type EditWidgetDrawerProps = {
  open?: boolean;
  widget: DashboardWidget;
  dashboardId: string;
};

export function EditWidgetDrawer({
  open = false,
  widget,
  dashboardId,
}: EditWidgetDrawerProps) {
  const { close } = useModal();

  return (
    <Drawer.Root
      opened={open}
      closeOnClickOutside={false}
      closeOnEscape={false}
      onClose={() => close()}
      position="right"
      classNames={{
        overlay: c('overlay'),
        inner: c('inner'),
        content: c('content'),
      }}
      padding={0}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <WidgetForm widget={widget} dashboardId={dashboardId} />
      </Drawer.Content>
    </Drawer.Root>
  );
}
